<template>
  <div class="overlay"></div>
</template>

<style scoped>
.overlay {
  background-color: hsla(0, 0%, 0%, 0.4);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
